import { initReactI18next } from 'react-i18next'

import LanguageDetector from 'i18next-browser-languagedetector'
import de from 'assets/locales/de/translation.json'
import en from 'assets/locales/en/translation.json'
import es from 'assets/locales/es/translation.json'
import fr from 'assets/locales/fr/translation.json'
import he from 'assets/locales/he/translation.json'
import hi from 'assets/locales/hi/translation.json'
import it from 'assets/locales/it/translation.json'
import ja from 'assets/locales/ja/translation.json'
import ko from 'assets/locales/ko/translation.json'
import no from 'assets/locales/no/translation.json'
import pl from 'assets/locales/pl/translation.json'
import pt from 'assets/locales/pt/translation.json'
import ro from 'assets/locales/ro/translation.json'
import ru from 'assets/locales/ru/translation.json'
import uk from 'assets/locales/uk/translation.json'
import zh from 'assets/locales/zh/translation.json'
import i18next from 'i18next'

void i18next.use(initReactI18next).use(LanguageDetector).init({
  fallbackLng: 'en',
  resources: {
    de,
    en,
    es,
    fr,
    he,
    hi,
    it,
    ja,
    ko,
    no,
    pl,
    pt,
    ro,
    ru,
    uk,
    zh,
  },
  returnNull: false,
})

export function localeToLanguage(locale: string) {
  return locale.replace('_', '-').split('-')[0]
}

export default i18next
